/* eslint-disable no-debugger */
import { BASIC_INITIAL_STATE, NO_DATA_MESSAGE, ClubHttpHelper } from "@usas/ui-web/utils/HttpHelper";

const searchClubAthleteRosterData = (usasClubId, filterObj, state, setState) => {
  if (usasClubId && state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      filterObj: filterObj,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const usasClubIdForUrl = usasClubId ? encodeURIComponent(usasClubId) : 'NaN';
    const url = `/usasClub/${usasClubIdForUrl}/roster?filter=${encodeURIComponent(JSON.stringify(filterObj))}`;
    ClubHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const INITIAL_CLUB_ATHLETE_ROSTER_STATE = {
  ...BASIC_INITIAL_STATE,
  filterObj: {}
};

const ClubAthleteRosterData = {
  INITIAL_STATE: INITIAL_CLUB_ATHLETE_ROSTER_STATE,
  searchClubAthleteRosterData
};

export default ClubAthleteRosterData;